import { GridHalf, PageGrid, SectionLabel, Window } from '@/components/base/Grid';
import { movePanels, services } from '@/mocks/content';

export function Manifesto() {
  return (
    <PageGrid label="The idea" dark className="rev lg:grid-rows-[auto_auto] !border-t-0 bg-primary-500 text-background-50">
      <GridHalf className="bg-primary-500 flex flex-col lg:grid lg:row-span-2 lg:[grid-template-rows:subgrid]">
        <div className="cell flex flex-col justify-end gap-8">
          <div className="reveal">
            <p className="t-h3 font-normal max-w-[520px]">Local discovery is a series of decisions.</p>
            <p className="mt-4 t-body text-background-300 max-w-[480px]">We connect search visibility, useful content and better digital experiences to the moments when customers choose.</p>
          </div>
        </div>
        <div className="qgrid border-t rule-dark">
          {movePanels.map((p, i) => (
            <div key={p.n} className={`px-cell py-7 lg:py-8 min-h-[170px] flex flex-col justify-between gap-6 reveal ${i === 2 ? 'bg-accent-500/15' : 'bg-primary-500'}`} style={{ transitionDelay: `${i * 70}ms` }}>
              <span className={`t-label ${i === 2 ? 'text-accent-400' : 'text-background-400'}`}>{p.n}</span>
              <div>
                <h3 className="font-heading text-[18px] lg:text-[20px] font-medium tracking-[-0.02em]">{p.title}</h3>
                <p className="mt-1.5 text-[14px] text-background-300 leading-relaxed">{p.text}</p>
              </div>
            </div>
          ))}
        </div>
      </GridHalf>
      <GridHalf side="r" className="bg-primary-500 flex flex-col lg:grid lg:row-span-2 lg:[grid-template-rows:subgrid]">
        <div className="cell flex-1 flex flex-col justify-between gap-14">
          <SectionLabel index="01" dark>The idea</SectionLabel>
          <h2 className="t-edit max-w-[620px] reveal">
            Be the business they find <span className="bg-accent-500 text-foreground-950 px-2 -mx-0.5">first.</span>
          </h2>
        </div>
        <div className="qgrid border-t rule-dark">
          <div className="px-cell py-7 lg:py-8 flex flex-col justify-between gap-6 reveal">
            <span className="t-label text-background-400">Why it matters</span>
            <p className="text-[15px] text-background-300 leading-relaxed">Nearby customers rarely scroll far. The businesses they see first are the ones they call first.</p>
          </div>
          <div className="px-cell py-7 lg:py-8 bg-background-50/[0.05] text-background-50 flex flex-col justify-between gap-6 reveal" style={{ transitionDelay: '80ms' }}>
            <span className="t-label text-background-400">Path</span>
            <ol className="flex flex-col gap-2 t-label">
              {['Search', 'Compare', 'Verify', 'Contact'].map((s, i) => (
                <li key={s} className="flex items-center gap-3">
                  <span className={`w-1.5 h-1.5 ${i === 3 ? 'bg-accent-500' : 'bg-background-50/40'}`} />{s}
                </li>
              ))}
            </ol>
          </div>
        </div>
      </GridHalf>
    </PageGrid>
  );
}

export function Expertise() {
  return (
    <PageGrid id="expertise" label="Expertise">
      <GridHalf className="flex flex-col">
        <div className="bg-white flex-1">
          <div className="stick cell flex flex-col gap-10">
            <SectionLabel index="02">What we do</SectionLabel>
            <div className="reveal">
              <h2 className="t-edit">Built to be found.</h2>
              <p className="mt-6 t-body text-foreground-700 max-w-[420px]">Four connected disciplines, each focused on the moment someone nearby looks for what you offer.</p>
            </div>
          </div>
        </div>
        <Window className="h-[300px] lg:h-[360px] border-t rule" tag="Fig. 02 — Reach" caption="One field, four disciplines" />
      </GridHalf>
      <GridHalf side="r" className="bg-white">
        <ul className="h-full grid auto-rows-fr">
          {services.map((s, i) => (
            <li key={s.n} className="border-t rule first:border-t-0 reveal" style={{ transitionDelay: `${i * 60}ms` }}>
              <a href="#contact" className="group relative grid grid-cols-[40px_minmax(0,1fr)_auto] gap-x-4 h-full px-cell py-9 lg:py-12 lg:min-h-[260px] cursor-pointer hover:bg-background-50 transition-colors duration-300">
                <span className="absolute left-0 top-0 bottom-0 w-[3px] bg-accent-600 origin-top scale-y-0 group-hover:scale-y-100 transition-transform duration-300" />
                <span className="t-label text-foreground-600 pt-2">{s.n}</span>
                <div>
                  <div className="flex items-center gap-3 flex-wrap">
                    <h3 className="t-h3"><span className="uline pb-1">{s.title}</span></h3>
                    <span className="t-label text-foreground-500 border rule px-1.5 py-0.5 group-hover:bg-accent-500 group-hover:border-accent-500 group-hover:text-foreground-950 transition-colors duration-200">{s.tag}</span>
                  </div>
                  <p className="mt-3 text-[15px] text-foreground-700 leading-relaxed max-w-[440px]">{s.text}</p>
                </div>
                <span className="w-9 h-9 flex items-center justify-center text-foreground-600 group-hover:text-foreground-950">
                  <i className="ri-arrow-right-up-line text-lg arrow-nudge" />
                </span>
              </a>
            </li>
          ))}
        </ul>
      </GridHalf>
    </PageGrid>
  );
}